import React, { Component } from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
import '../../../../SCSS/payroll.scss';
import '../../../../SCSS/common-payment.scss';
import '../../../../SCSS/create-invoice.scss';
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import Loader from "../../../utils/loader/loaders";
import KenForm from "../../../../global_components/KenForm/zqform";
// import ZenSwitch from "../../input/switch";
import HolidayJson from './holiday.json';
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import moment from "moment";
// import ZqHistory from "../../../gigaLayout/change-history";
import { Drawer } from "rsuite";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import zq_api from "../../../utils/api-service";
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined'
import LinearProgress from '@material-ui/core/LinearProgress'
import xlsx from "xlsx";
class Holidays extends Component {
  constructor(props) {
    super(props);
    // this.zq_api = new zq_api();
    this.state = {
      env: JSON.parse(localStorage.getItem("env")),
      useremail: localStorage.getItem("email"),
      channel: localStorage.getItem("channel"),
      BranchId: localStorage.getItem("branchid"),
      authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
      orgId: "606ac70479dbb25447375fa8",
      orgName: localStorage.getItem("orgName"),
      userId: localStorage.getItem("userID"),
      instituteId: localStorage.getItem("instituteId"),
      username: localStorage.getItem("username"),
      tabview: true,
      preview: true,
      holidayData: HolidayJson,
      serviceName: "",
      noProg: "",
      loader: false,
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 1,
      history: false,
      showHistory: false,
      historyData: [],
      submitCheck: false,
      holidayData2: [
        {
          "S.No": 1,
          "Holiday Description": "New Year",
          "Holiday Date": "01/01/2021",
          "Holiday Type": "Optional"
        }
      ],
      noProg: "Fetching Data...",
      isLoader: false,
      containerNav: {
        isBack: false,
        name: "List of Holidays",
        isName: false,
        isSearch: false,
        isSort: false,
        isPrint: false,
        isDownload: false,
        isShare: false,
        isNew: false,
        newName: "New",
        isSubmit: false,
        isUpload: true,
        uploadName: 'Upload',
        isDownloadProcessing: true,
        dwnldPrcsBtn: "Download"
      },
      isUploadData: false,
      showUpload: false,
      uploadTemplatePayload: [],
      pdfLoaded: 0,
      processLoaded: 0,
      pdfName: undefined,
    };
    this.inputFile = React.createRef(this.inputFile);
  }
  componentDidMount() {
    this.getHolidayList();
  }

  getHolidayList = () => {
    this.setState({ isLoader: true })
    let settingsURL = `https://api.zenqore.com/payroll/uat/hkbk`
    Axios.get(`${settingsURL}/setup/payrollsettings?instituteid=${this.state.instituteId}`, {
      headers: {
        'Authorization': this.state.authToken
      }
    }).then(res => {

      let resData = res.data[0].holidays;
      console.log("resData", resData)
      console.log("resData", Object.keys(resData))
      let holidayData2 = [];
      Object.keys(resData).map(i => {
        let item = resData[i]
        holidayData2.push({
          "ID": item.id,
          "Holiday Description": item.name,
          "Holiday Date": this.onGetDateFormat(item.fromDate),
          "Holiday Type": item.type,
          "Status": item.status,
          "Item": JSON.stringify(item)
        })
      })
      this.setState({ holidayData2, isLoader: false })

    }).catch(err => {
      console.log("err", err)
      this.setState({ noProg: "Error Loading Data", isLoader: false })
    })
  }

  onGetDateFormat = (d) => {
    let date = new Date(d)
    return `${String(date.getDate()).length == 1
      ? `0${date.getDate()}`
      : date.getDate()
      }/${String(date.getMonth() + 1).length == 1
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1
      }/${date.getFullYear()}`
  }
  onPreviewServices = (item) => {
    // let holidayData = this.state.holidayData;
    // let details = JSON.parse(item.Item);
    // let objKeys = Object.keys(details);
    // let entityInstanceId = details["_id"];
    // let bankName = details.bankName
    // console.log("details", details);

    // this.setState({ tabview: false, showUpload: true, preview: true, apiCall: true, entityInstanceId: entityInstanceId, bankName });
    // objKeys.map((key) => {
    //   holidayData.map((item) => {

    //     // let keyName = key.toLowerCase().replace(/ /g, "");

    //     // let name = String(details['Department Head']).split()
    //     // if (item.name == "ID") {
    //     //     item["defaultValue"] = details['ID'];
    //     //     item["readOnly"] = false;
    //     //     item["required"] = false;
    //     // }
    //     if (item.name == "ID") {
    //       item["defaultValue"] = details['sNo'];
    //       item["readOnly"] = false;
    //       item["required"] = false;
    //     }
    //     else if (item.name == "Name") {
    //       item["defaultValue"] = details['name'];
    //       item["readOnly"] = false;
    //       item["required"] = false;
    //     }
    //     else if (item.name == "description") {
    //       item["defaultValue"] = details['description'];
    //       item["readOnly"] = false;
    //       item["required"] = false;
    //     }
    //     else if (item.name == "fromdate") {
    //       item["defaultValue"] = details['fromDate'];
    //       item["readOnly"] = false;
    //       item["required"] = false;
    //     }
    //     else if (item.name == "todate") {
    //       item["defaultValue"] = details['toDate'];
    //       item["readOnly"] = false;
    //       item["required"] = false;
    //     }
    //     else if (item.name == "isOptional") {
    //       item['defaultValue'] = details.isOptional ? "true" : "false"
    //       item['readOnly'] = false
    //       item['required'] = false
    //     }
    //   })
    // })
    // this.setState({ holidayData });
  };

  onSubmit = (data, item) => {
    console.log("dataitem", data, item)
    let userData = this.state.holidayData;
    let apiNewCall = true;
    userData.map(item => {
      if (item.requiredBoolean) {
        if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
          item["error"] = true;
          item["validation"] = true
          item['errorMsg'] = `Invalid ${item.label}`
          apiNewCall = false
        } else {
          item["error"] = false;
          item["validation"] = false;
        }
      }
    })
    this.setState({ holidayData: userData }, () => {
      if (apiNewCall) {
        this.setState({ isLoader: true }, () => {
          let payloadInput = {}
          this.state.holidayData.map(item => {
            if (item.type != "heading" && item.category != "button") {
              payloadInput[item.name] = item.defaultValue
            }
          })
          let payload = {
            "id": String(payloadInput.ID),
            "name": payloadInput.Name,
            "Description": payloadInput.description,
            "fromDate": payloadInput.fromdate,
            "toDate": payloadInput.todate,
            "isOptional": payloadInput.isOptional,
            "createdBy": this.state.userId,
            "updatedBy": this.state.userId,
            "status": "Active",
          }
          console.log("payloadInput", payload)
          // var headers = {
          //   'Authorization': localStorage.getItem('auth_token')
          // }
          // if (!this.state.apiCall) {
          //   Axios.post(`${this.state.env['getUserProfile']}/masters/designation`, payload, { headers: headers })
          //     .then(res => {
          //       this.setState({ snackBar: true, processMessage: res.data.message }, () => {
          //         setTimeout(() => {
          //           this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
          //             this.getDesignations();
          //           })
          //         }, 2000)
          //       })
          //     }).catch(err => {
          //       this.setState({
          //         loader: false
          //       }, () => {
          //         this.setState({ snackBar: true, processMessage: err }, () => {
          //           setTimeout(() => {
          //             this.setState({ snackBar: false }, () => {
          //             })
          //           }, 2000)
          //         })
          //       });
          //     })
          // }
          // else {
          //   Axios.put(`${this.state.env['getUserProfile']}/masters/designation?id=${this.state.entityInstanceId}`, payload, { headers: headers })
          //     .then(res => {
          //       this.setState({ snackBar: true, processMessage: res.data.message }, () => {
          //         setTimeout(() => {
          //           this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
          //             this.getDesignations();
          //           })
          //         }, 2000)
          //       })
          //     }).catch(err => {
          //       this.setState({
          //         loader: false
          //       }, () => {
          //         this.setState({ snackBar: true, processMessage: err }, () => {
          //           setTimeout(() => {
          //             this.setState({ snackBar: false }, () => {
          //             })
          //           }, 2000)
          //         })
          //       });
          //     })
          // }
        })
      }

    })

  }

  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getServices();
    });
  };
  resetform = () => {
    let holidayData = this.state.holidayData;
    holidayData.map((item) => {
      item["defaultValue"] = undefined;
      item["readOnly"] = false;
      item["error"] = false;
      item["required"] = item.requiredBoolean
      item["validation"] = false
    });
    this.setState(holidayData);
  };
  onAddServices = () => {
    let holidayData = this.state.holidayData;
    holidayData.map((item) => {
      if (item.name == 'ID') {
        item["defaultValue"] = "";
        item["readOnly"] = false;
        //   item["error"] = false;
        //   item["required"] = item.requiredBoolean
        //   item["validation"] = false
      }
    });

    this.setState({ holidayData: HolidayJson }, () => {
      this.setState({ tabview: false, preview: false, showUpload: true });
    });
  };
  handleBack = () => {
    if (this.props.location.status != "active") {
      this.resetform();
      this.setState({ tabview: true });
    } else {
      this.props.history.goBack();
    }
  };
  onInputChanges1 = (value, item, e, dataS) => {
    if (dataS != undefined) {
      if (dataS.name == "Transaction") {
        this.setState({ Transaction: value });
        let { ServiceFormData } = this.state;
        if (value == "Sell") {
          ServiceFormData = ServiceFormData.filter((task) => {
            if (
              task.name != "TDS/Withholding Tax" &&
              task.name != "TDS Applicable"
            ) {
              return task;
            }
          });
          this.setState({ ServiceFormData }, () => {
            console.log(ServiceFormData);
          });
        } else {
          // this.setState({ ServiceFormData: ServiceData });
        }
      }
      if (dataS.name == "GST Tax Rate") {
        this.setState({ "GST Tax Rate": value });
      }
      if (dataS.name == "TDS/Withholding Tax") {
        this.setState({ "TDS/Withholding Tax": value });
      }
      if (dataS.name == "TDS Applicable") {
        this.setState({ "TDS Applicable": value });
      }
      if (dataS.name == "Discount Start Date") {
        this.setState({ date1: new Date(value).valueOf() });
      }
      if (dataS.name == "Discount End Date") {
        this.setState({ date2: new Date(value).valueOf() });
      }
    } else {
      // this.onSetValue(item.name, value, true
    }
  };
  formBtnHandle = (item) => {
    return item.type === "clear" ? this.cleartabData() : this.canceltabData();
  };
  cleartabData = () => {
    let issueDetailData = [];
    let formData = this.state.ServiceFormData;
    this.setState({ ServiceFormData: [] }, () => {
      formData.map((item) => {
        item["defaultValue"] = undefined;
        item["readOnly"] = false;
        if (item.required) {
          item["validation"] = false;
        }
      });
      issueDetailData = formData;
      console.log(issueDetailData, "issueDetailData");
      this.setState({
        ServiceFormData: issueDetailData,
      });
    });
  };
  canceltabData = () => {
    this.resetform();
    this.setState({ tabview: true });
  };

  onCloseForm = () => {
    this.setState({ showHistory: false });
  };

  onUpload = () => {
    this.setState({ tabview: false, isUploadData: true, showUpload: false })
  }

  uploadCancel = () => {
    this.setState({ tabview: true, isUploadData: false, showUpload: false })
  }
  onInputChanges = (value, item, e, dataS) => {
    console.log("value", value)
    console.log("item", item)
    console.log("e", e)
    console.log("dataS", dataS)
    if (dataS != undefined) {
      if (dataS["name"] === "type") {
        dataS["defaultValue"] = value;

      }
    }
    else {
      item["defaultValue"] = value
    }

  }

  fileSelected = (ev, i) => {
    console.log(ev.target.files)


    const file = ev.target.files[0];
    // let EmployeeJson = {}
    // reader.onload = (event) => {
    //     const data = reader.result;
    //     workBook = xlsx.read(data, { type: 'binary' });
    //     jsonData = workBook.SheetNames.reduce((initial, name) => {
    //         const sheet = workBook.Sheets[name];
    //         initial[name] = xlsx.utils.sheet_to_json(sheet);
    //         return initial;
    //     }, {});
    //     // const dataString = JSON.stringify(jsonData);
    //     const dataString = jsonData;
    //     EmployeeJson = dataString;
    //     console.log("json converted data", EmployeeJson);

    //     this.setState({ uploadTemplatePayload: data })
    // }
    // reader.readAsBinaryString(file);
    this.setState({ upload: true, filename: file.name, uploadTemplatePayload: file }, () => {
      this.onLoad(0)
    })
  }

  submitProcessingTemplate = () => {
    var formData = new FormData();
    var payload = this.state.uploadTemplatePayload;
    console.log('filename', this.state.filename)
    // formData.append('file', this.state.uploadTemplatePayload);
    formData.append("file", this.state.uploadTemplatePayload, this.state.filename)
    formData.append("orgId", this.state.orgId);
    console.log(formData)
    this.setState({ isLoader: true, holidayData2: [] }, () => {

      let config = {
        headers: {
          "Authorization": this.state.authToken,
          'Content-Type': 'multipart/form-data'
        }
      }
      Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/add/holidays`, formData, config)
        .then(response => {
          // res.json().then(response => {
          console.log("processing upload template api response", response);
          setTimeout(() => {
            this.getHolidayList();
          }, 1000);
          this.setState({ tabview: true, upload: false, isUploadData: false })
          this.setState({ noProg: "Fetching Details..", MonthLists: [] })
        })
        .catch(err => {
          console.log("error occured in processing upload submit API");
          this.setState({ noProg: "No Data", tabview: true, upload: false, isUploadData: false })
          this.setState({ isLoader: false })
        })

    })
  }

  onLoad = load => {
    if (this.state.pdfLoaded == 100) {
      if (this.state.processLoaded < 100) {
        let loadValue = this.state.processLoaded + 5
        this.setState({ processLoaded: loadValue }, () => {
          setTimeout(() => {
            this.onLoad(loadValue)
          }, 100)
        })
      } else {
        this.setState({ extractData: true }, () => {

        })
      }
    } else {
      let loadValue = this.state.pdfLoaded + 5
      this.setState({ pdfLoaded: loadValue }, () => {
        setTimeout(() => {
          this.onLoad(loadValue)
        }, 100)
      })
    }
  }

  onDownload = () => {
    let createXlxsData = [{
      "ID *": "",
      "Name *": "",
      "Description": "",
      "From Date": "",
      "To Date": "",
      "Is Optional": "",
      "Status": ""
    }]
    var wscols = []
    var findCellWidth = {}
    var cellKeys = Object.keys(createXlxsData['0'])
    createXlxsData.map((key, keyIndex) => {
      cellKeys.map(cellKey => {
        if (findCellWidth[cellKey] != undefined) {
          findCellWidth[cellKey] = Number(findCellWidth[cellKey]) > String(key[cellKey]).length ? findCellWidth[cellKey] : String(key[cellKey]).length
        } else {
          console.log(cellKeys[cellKey], String(cellKeys[cellKey]).length)
          findCellWidth[cellKey] = Number(String(cellKey).length)
        }
      })
    })
    console.log(findCellWidth)
    cellKeys.map(cellKey => {
      wscols.push({ wch: findCellWidth[cellKey] + 5, s: { font: { bold: true } } })
    })
    console.log(xlsx)
    var ws = xlsx.utils.json_to_sheet(createXlxsData);
    ws['!cols'] = wscols;
    var wb = xlsx.utils.book_new();
    var sheetMonth = `Add Holiday Lists`
    console.log('sheetMonth', sheetMonth)
    xlsx.utils.book_append_sheet(wb, ws, sheetMonth);
    xlsx.writeFile(wb, `${sheetMonth}.xlsx`);
  }

  render() {
    const onButtonClick = () => {
      this.inputFile.current.click()
    }
    return (
      <React.Fragment>
        {/* {this.state.isLoader ? <Loader /> : null} */}
        <div className="setup-page-wrapper">
          {this.state.tabview ? (
            <React.Fragment>

              {this.state.containerNav == undefined ? null : (
                <React.Fragment>
                  <KenContainerNavbar
                    containerNav={this.state.containerNav}
                    onUpload={() => { this.onUpload() }}
                    onDownload={() => { this.onDownload() }}
                    onAddNew={() => {
                      this.resetform();
                      this.onAddServices();
                    }}
                  />
                  <div className="print-time">{this.state.printTime}</div>
                </React.Fragment>
              )}
              <div className="trial-balance-header-title">
                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                  marginRight: '5px',
                  cursor: 'pointer',
                  marginTop: '0px'
                }} />
                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Holiday List</p>
              </div>
              <div
                className="table-wrapper"
                style={{ marginTop: "10px" }}
              >
                {this.state.holidayData2.length == 0 ||
                  this.state.loader ? (
                  <p className="noprog-txt">{this.state.noProg}</p>
                ) : (
                  <React.Fragment>
                    <div className="remove-last-child-table remove-first-child-table">
                      <KenTable
                        data={this.state.holidayData2}
                        rowClick={(item) => {
                          this.onPreviewServices(item);
                        }}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="setup-pagination">
                  {this.state.holidayData2.length !== 0 && (
                    <KenPaginationUI
                      total={this.state.totalRecord}
                      onPaginationApi={this.onPaginationChange}
                      totalPages={this.state.totalPages}
                      limit={this.state.limit}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {this.state.showUpload ?

                <div className="tab-form-wrapper">
                  <div className="goods-btns services-btns">
                    <div className="preview-header-wrap">
                      <div className="trial-balance-header-title">
                        <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.handleBack() }} style={{
                          marginRight: '5px',
                          cursor: 'pointer',
                          marginTop: '0px'
                        }} />
                        {this.state.preview ?
                          <p className="top-header-title" onClick={() => { this.handleBack() }}>| Holiday | {this.state.designationId}</p> :
                          <p className="top-header-title" onClick={() => { this.handleBack() }}>| Holiday</p>}
                      </div>

                    </div>

                  </div>
                  <div className="goods-wrapper service-wrapper form-heading-tab">

                    <KenForm
                      formData={this.state.holidayData}
                      className="goods-wrap"
                      onInputChanges={this.onInputChanges}
                      onFormBtnEvent={(item) => {
                        this.formBtnHandle(item);
                      }}
                      clear={true}
                      onSubmit={this.onSubmit}
                    />
                  </div>

                </div>
                :
                <>
                  {
                    this.state.isUploadData ?
                      <div className='invoice-page-wrapper'>
                        <div className='create-invoice-page-header' style={{ display: 'flex', marginBottom: '20px' }}>
                          <div className='header-title' style={{ width: '50%' }}>
                            <div className='goods-btns'>
                              <div className='goods-header-wrap'>
                                <h6 className='goods-Id-content'>Upload Holiday Excel</h6>
                              </div>
                            </div>
                          </div>
                          <div className="footer-btn-grps" style={{ top: "56px" }}>
                            <button variant="contained" type="cancel" className="add-item-btn cancel-btn" onClick={this.uploadCancel}>Cancel</button>
                            <button variant="contained" type="submit" className="add-item-btn approval-btn" onClick={this.submitProcessingTemplate}>Submit</button>
                          </div>
                        </div>
                        <div className='invoice-custom-table-wrapper invoice-extract-wrap'>

                          {/* {this.state.UploadBankData.length > 0 ? (
                            <ZenForm
                              inputData={this.state.UploadBankData}
                              onInputChanges={this.onInputChanges}
                              onSubmit={this.onSubmit}
                              onFormBtnEvent={this.onFormBtnEvent}
                            />
                          ) : null} */}
                          <div className='pdf-extract-wrap' style={{ height: '70%' }}>
                            <div className='onboard-card dot-card' onClick={onButtonClick} style={{ height: "140%" }} >
                              {this.state.upload ? (
                                <React.Fragment>
                                  <div className='file-upload-wrap' onClick={event => { event.stopPropagation() }} >
                                    {this.state.pdfLoaded !== 100 ? (
                                      <span className='file-loaded-percentage'>{this.state.pdfLoaded}%</span>) :
                                      (<span className='file-loaded-percentage' style={{ fontSize: '14px', color: '#00b8d9' }}>
                                        <i class='fa fa-check' aria-hidden='true'></i>
                                      </span>
                                      )}
                                    <p className='file-process-hd'> Uploading File({this.state.filename}) </p>
                                    <LinearProgress color='primary' variant={'determinate'} value={this.state.pdfLoaded} />

                                    {this.state.processLoaded !== 100 ? (
                                      <span className='file-loaded-percentage process-percentage'>
                                        {this.state.processLoaded}%
                                      </span>
                                    ) : (
                                      <span
                                        className='file-loaded-percentage process-percentage'
                                        style={{
                                          fontSize: '14px',
                                          color: '#00b8d9'
                                        }}
                                      >
                                        <i class='fa fa-check' aria-hidden='true'></i>
                                      </span>
                                    )}
                                    <p className='file-process-hd'>Processing File</p>
                                    <LinearProgress
                                      color='primary'
                                      variant={'determinate'}
                                      value={this.state.processLoaded}
                                    />
                                  </div>
                                </React.Fragment>
                              ) : (
                                <div>
                                  <input
                                    type='file'
                                    id='file'
                                    ref={this.inputFile}
                                    style={{ display: 'none' }}
                                    onChange={this.fileSelected}
                                  />
                                  <div className='card-third-round  '>
                                    <PublishOutlinedIcon className='onboard-icons' />
                                  </div>
                                  <h6 className='onboard-card-header'>Upload Excel</h6>
                                  <p className='onboard-card-title' style={{ color: '#000' }} >Drag and drop file or <span className='browse-content'>browse</span>
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      :
                      null
                  }
                </>
              }



            </React.Fragment>
          )}



        </div>
        {/* {this.state.history ? (
          <Drawer show={this.state.showHistory} onHide={this.close}>
            <ZqHistory
              historyData={this.state.historyData}
              onCloseForm={this.onCloseForm}
            />
          </Drawer>
        ) : null} */}
      </React.Fragment>
    );
  }
}
export default withRouter(Holidays);